import * as React from 'react';

const Pt24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#060", d: "M10 6H5a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h5z" }), /* @__PURE__ */ React.createElement("path", { fill: "red", d: "M19 6h-9v12h9a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2" }), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#FFCC4D",
    d: "M10 8c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4m-3.1 2.3.8.8-1.2.6c.1-.5.2-1 .4-1.4m-.4 2 2.2 1.1-1.3.9c-.5-.5-.8-1.2-.9-2m3 3.2c-.5-.1-.9-.3-1.3-.5h1.3zm0-1H8l1.5-1zm0-1.6-.3.2L7.1 12l1.1-.5zm0-.8-1.8-1.7 1.8.3zm0-1.9-2.2-.4c.5-.7 1.3-1.1 2.2-1.3zm3.6.1c.2.4.4.9.4 1.4l-1.2-.6zm-2.6-1.8c.9.1 1.7.6 2.2 1.3l-2.2.4zm0 2.2 1.8-.3-1.8 1.7zm0 2.2 1.4-1.4 1 .5-2.1 1.1zm0 2.6V15h1.3c-.4.2-.8.4-1.3.5m0-1v-1l1.5 1zm2.1-.2-1.3-.9 2.2-1.1c-.1.8-.4 1.5-.9 2"
  }
), /* @__PURE__ */ React.createElement("path", { fill: "#D52B1E", d: "M7.7 9.5v3.1c0 1.3 1 2.3 2.3 2.3s2.3-1 2.3-2.3V9.5z" }), /* @__PURE__ */ React.createElement("path", { fill: "#F1F2F1", d: "M8.3 10.1v2.5c0 .9.8 1.7 1.7 1.7s1.7-.8 1.7-1.7v-2.5z" }), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#039",
    d: "M9.3 11.637h-.7v.9h.7zm1.05 0h-.7v.9h.7zm1.05 0h-.7v.9h.7zm-1.05-1.25h-.7v.9h.7zm0 2.5h-.7v.9h.7z"
  }
));
Pt24.Size = 24;
Pt24.Title = "Pt";

export { Pt24 as default };
